 import development from './development';
//import production from './production';
const env = process.env.NODE_ENV;
// const components = { development, production }
export default development;
